<div class="flex flex-row justify-between items-center solution-card p-24 m-4" [ngClass]="{'cursor-pointer': !loader}"
     (click)="!loader ? goToBlueprintSummary() : ''">
  <div class="flex flex-row sandbox">
    <img src="/assets/images/sandbox.png" class="w-40 h-30 mr-20">
    <div class="mat-subtitle-2 mb-0 service-name word-break-word pr-4">{{ sandbox?.service?.name ? sandbox?.service?.name : sandboxInfo?.name}}</div>
  </div>
  <div *ngIf="!loader; else skeletonLoader" class="flex flex-row w-25-percent status">
    <ng-container *ngIf="DeployStatus.DEPLOYED === sandbox?.instance?.status && trialStatus.includes('expired'); else isNotExpired">
      <div *ngIf="sandbox?.instance?.status" class="warn-solid-bg traffic-light icon-container mr-16">
        <mat-icon svgIcon="error_outline" class="flex justify-center items-center white-fg icon icon-sm"></mat-icon>
      </div>
      <div class="mat-subtitle-2 fw-600">
        {{'SANDBOX.EXPIRED' | transloco}}
      </div>
    </ng-container>
    <ng-template #isNotExpired>
      <ng-container
        *ngIf="[DeployStatus.DEPLOYING, DeployStatus.TERMINATING, DeployStatus.UPDATING].includes(sandbox?.instance?.status); else showIconStatuses">
        <div *ngIf="instanceStatus" [ngClass]="statusInfo[sandbox?.instance?.status]?.colorClass"
            class="traffic-light icon-container mr-20 accent-1-bg">
          <mat-icon svgIcon="change_circle" class="flex justify-center items-center white-fg icon-sm"></mat-icon>
        </div>
      </ng-container>
      <ng-template #showIconStatuses>
        <div *ngIf="instanceStatus" [ngClass]="statusInfo[sandbox?.instance?.status]?.colorClass"
            class="traffic-light icon-container mr-20">
          <mat-icon class="white-fg icon-sm" [svgIcon]="statusInfo[sandbox?.instance?.status]?.icon"></mat-icon>
        </div>
      </ng-template>
      <div class="mat-subtitle-2 fw-600 mb-0 word-break-word">
        {{(sandbox?.instance?.status ? 'INSTANCE_STATUS.' + sandbox?.instance?.status : 'INSTANCE_STATUS.NA') | transloco}}
      </div>
    </ng-template>
  </div>
  <div class="flex flex-row justify-center items-center">
    <div *ngIf="!loader; else skeletonLoader" class="mat-subtitle-2 fw-500 ml-16 mr-80 mb-0 expiry" [ngClass]="{'warn-solid-fg' : trialStatus.includes('expired')}">
      <span *ngIf="sandbox?.instance?.status !== DeployStatus.DEPLOYING && sandbox?.instance?.status !== DeployStatus.FAILED">{{trialStatus}}</span>
    </div>
      <!-- <mat-icon svgIcon="chat_bubble_outline" [ngClass]="{'disabled': !sandboxInfo?.service?.punchline}" class="icon-md ml-auto mr-18" [matTooltip]="sandboxInfo?.service?.punchline"
      matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon>
      <mat-icon svgIcon="token" [ngClass]="{'disabled': !releaseVersion}" class="icon-md mr-18" [matTooltip]="isAMR? ('Release ' + releaseVersion + ' | AMR'): ('Release ' + releaseVersion)"
        matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon>
      <mat-icon svgIcon="layers" [ngClass]="{'disabled': !capabilities}" class="icon-md ml-auto mr-18" matTooltip="{{capabilities}} Capabilities"
      matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16"></mat-icon> -->
  </div>
  <ng-template #skeletonLoader>
    <div class="pl-6 skeleton-loader">
      <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
    </div>
  </ng-template>
</div>
